import { baseURL, projectId, get, post, remove, put } from './config'

export const isRefresh = true
export const uploadURL = baseURL + '/api/v1/portal/common/uploads'
// 上传财务数据excel文件 的地址
export const uploadFundExcel = baseURL + '/api/v1_11/cooperation/budget/expense/excel'
// export const downloadURL = baseURL + `/media/${media_id}/download`

/* export const downloadModel = {
  'production': '',
  'development': 'http://192.168.1.186:9903/预算科目模版.xlsx',
  'lan': 'http://192.168.1.124:8060/预算科目模版.xlsx'
}[process.env.NODE_ENV] */

/*
  -- api 调用 示例
    this.loading = true
    api.getDocsList({
      docs_type: this.docs_type,
      ...this.pagination
    }).then(res => {
      if (res.data.code === 0) {
        console.log('文档列表', res.data.data)
        this.pagination.total = res.data.data.total
        this.tableData = res.data.data.data
      } else {
        this.$message.error('获取文档列表失败')
        console.log(res)
      }
      this.loading = false
    }).catch((error) => {
      console.log(error)
      this.$message.error(`网络错误，请检查网络设置`)
      this.loading = false
    })
*/

/**
 * 用户注册
 * @param {*} data
 */
export const register = (data) => post(`/api/v1_11/register`, data)

/**
 * 用户登录
 * @param {*} data
 */
export const login = (data) => post(`/api/v1_11/login`, data)

/**
 * 用户申请加入课题
 * @param {*} data
 */
export const apply = (data) => post(`/api/v1_11/subject/invite`, data)

/**
 * 忘记密码时检验短信验证码
 * 验证不通过不返 code：0
 * @param {*} data
 */
export const resetPwValidateSmsCode = (data) => post(`/api/v1_11/sms/reset_pwd`, data)

/**
 * 忘记密码时设置新的密码
 * @param {*} resetToken
 * @param {*} data
 */
export const resetPwSetNewPw = (resetToken, data) => put(`/api/v1/validation/reset_pwd/${resetToken}`, data)

/**
 * 通用的获取短信验证码的接口
 * @param {*} data
 */
export const getSms = (data) => post(`/api/v1/validation/common_sms_validate`, data)
/*
  ============== start 账号管理 ==================
*/

/**
 * 获取用户信息
 */
export const getUserInfo = () => get(`/api/v1_11/account/info`)

/**
 * 修改用户信息
 */
export const updateUserInfo = (data) => put(`/api/v1_11/account/info`, data)

/**
 * 更新用户密码
 * @param {*} data
 */
export const updateUserPw = (data) => put(`/api/v1_11/account/reset_pwd`, data)

/*
  ============== end 账号管理 ==================
*/

/*
  ============== start 首页 ==================
*/

/**
 * 获取首页信息
 */
export const getHomeData = () => get(`/api/v1_11/index`)

/**
 * 获取项目信息
 *  - 包含公告
 */
export const getProjectInfo = () => get(`/api/v1_11/project`)

/**
 * 更新项目信息
 *  - 包含公告
 */
export const updateProjectInfo = (data) => put(`/api/v1_11/project`, data)

/*
  ============== end 首页 ==================
*/

/*
  ============== start 首页里程碑 ==================
*/

/**
 * 获取首页里程碑列表
 */
export const getMilestoneList = () => get(`/api/v1_11/cooperation/timeline`)

/**
 * 添加里程碑节点
 * @param {*} data
 */
export const addMilestoneNode = (data) => post(`/api/v1_11/cooperation/timeline/node`, data)

/**
 * 编辑里程碑节点
 * @param {*} data
 * @param {*} id
 */
export const updateMilestoneNode = (id, data) => put(`/api/v1_11/cooperation/timeline/node/${id}`, data)

/**
 * 删除里程碑节点
 * @param {*} id
 */
export const deleteMilestoneNode = (id) => remove(`/api/v1_11/cooperation/timeline/node/${id}`)

/*
  ============== end 首页里程碑 ==================
*/

/*
  ============== start 首页柱状图和饼图的统计 ==================
*/

/**
 * 柱状图
 * 获取首页图表统计课题目标进展
 * @param {*} data
 */
export const getHomeBarData = (data) => get(`/api/v1_11/cooperation/chart/target`, data)

/**
 * 饼图
 * 获取首页经费饼图统计数据
 */
export const getHomePieData = () => get(`/api/v1_11/cooperation/chart/budget`)

/*
  ============== end  首页柱状图和饼图的统计 ==================
*/

/*
  ============== start 议题 ==================
*/

/**
 * 获取帖子（议题）列表
 * @param {*} data
 */
export const getIssueList = (data) => get(`/api/v1_11/cooperation/issue`, data)

/**
 * 添加议题
 * @param {*} data
 */
export const addIssue = (data) => post(`/api/v1_11/cooperation/issue`, data)

/**
 * 删除议题
 * @param {*} id
 */
export const deleteIssue = (id) => remove(`/api/v1_11/cooperation/issue/${id}`)

/**
 * 更新议题信息
 * @param {*} id
 */
export const updateIssue = (id, data) => put(`/api/v1_11/cooperation/issue/${id}`, data)

/**
 * 更改议题状态
 * @param {*} id
 * @param {*} data
 */
export const updateIssueStatus = (id, data) => put(`/api/v1_11/cooperation/issue/${id}/complete`, data)

/**
 * 获取议题详情
 * @param {*} id
 */
export const getIssueDetails = (id) => get(`/api/v1_11/cooperation/issue/${id}`)

/**
 * 删除议题的评论的回复
 * @param {*} id
 * @param {*} data
 */
export const deleteIssueCommentReply = (id, data) => remove(`/api/v1_11/cooperation/issue/${id}/comment`, data)

/**
 * 添加回复或者评论
 * @param {*} id
 */
export const addIssueCommentOrReply = (id, data) => post(`/api/v1_11/cooperation/issue/${id}/comment`, data)

/*
  ============== start 议题 ==================
*/

/*
  ============== start 动态 ==================
*/

/**
 * 获取动态列表
 * @param {*} data
 */
export const getActivities = (data) => get(`/api/v1_11/activities`, data)

/**
 * 删除动态信息
 * @param {*} data
 */
export const deleteActivitie = (id) => remove(`/api/v1_11/activity/${id}`)

/**
 * 添加动态
 */
export const addActivitie = (data) => post(`/api/v1_11/activity`, data)

/**
 * 获取动态详情
 * @param {*} id
 */
export const getActivitieDetails = (id) => get(`/api/v1_11/activity/${id}`)

/*
  ============== end 动态 ==================
*/

/*
  ============== start 课题管理 ==================
*/

/**
 * 通过课题id 获取 课题下的单位列表
 * @param {*} id
 */
export const getTopicUnitListDown = (id) => get(`/api/v1_11/subject/${id}/company_down`)

/**
 * 获取课题详情
 * @param {*} id
 */
export const getTopicDetails = (id) => get(`/api/v1_11/subject/${id}`)

/**
 * 获取所有课题
 */
export const getAllTopic = () => get(`/api/v1_11/subject/all`)

/**
 * 获取课题编辑信息
 * @param {*} id
 */
export const getTopicEditInfo = (id) => get(`/api/v1_11/subject/${id}/details`)

/**
 * 编辑课题信息
 * @param {*} id
 * @param {*} data
 */
export const updateTopicInfo = (id, data) => put(`/api/v1_11/subject/${id}`, data)

/**
 * 获取课题目标下拉列表 [来源于课题的总目标部分]
 */
export const getTopicTargetDownList = (id) => get(`/api/v1_11/subject/${id}/target_down`)

/**
 * 根据年份获取季度下拉列表
 */
export const getQuarterDownList = (data) => get(`/api/v1_11/cooperation/subject/quarter/down`, data)

/**
 * 添加课题季度
 * @param {*} data
 */
export const addTopicQuarter = (data) => post(`/api/v1_11/cooperation/subject/quarter/item`, data)

/**
 * 添加课题目标/课题的季度目标 [不传： target_quarter_year , target_quarter_type ]
 * @param {*} data
 */
export const addTopicTargetOrQuarterTarget = (data) => post(`/api/v1_11/cooperation/subject/quarter/target`, data)

/**
 * 删除某季度下某目标项
 * @param {*} data
 */
export const deleteTopicQuarterTarget = (data) => remove(`/api/v1_11/cooperation/subject/quarter/target`, data)

/**
 * 获取课题里程碑列表
 * @param {*} data
 */
export const getTopicMilestoneList = (data) => get(`/api/v1_11/project/timeline/list`, data)

/**
 * 获取里程碑节点详情
 * @param {*} data
 */
export const getTopicMilestoneDetail = (data) => get(`/api/v1_11/project/timeline/node`, data)

/**
 * 新增课题里程碑和新增里程碑任务所用同一个接口
 *  如果传入了以下参数的话 则视为新增里程碑任务
 *  + parent_id
 *  + tag_id
 *  + user_id
 * @param {*} data
 */
export const addTopicMilestone = (data) => post(`/api/v1_11/project/timeline/add`, data)

/**
 * 更新里程碑/里程碑任务
 * @param {*} id
 * @param {*} data
 */
export const updateTopicMilestone = (id, data) => put(`/api/v1_11/project/timeline/${id}/update`, data)

/**
 *删除里程碑/里程碑任务
 * @param {*} id
 * @param {*} data
 */
export const deleteTopicMilestone = (id, data) => remove(`/api/v1_11/project/timeline/${id}/del`, data)

/**
 * 获取课题中里程碑的一级子任务列表
 * @param {*} data
 */
export const getTopicMilestoneTagList = (data) => get(`/api/v1_11/project/timeline/tags`, data)

/**
 * 添加课题一级子任务
 * @param {*} data
 */
export const addTopicMilestoneTag = (data) => post(`/api/v1_11/project/timeline/tag`, data)

/**
 * 删除课题一级子任务
 * @param {*} id
 * @param {*} data
 */
export const deleteTopicMilestoneTag = (id, data) => remove(`/api/v1_11/project/timeline/tag/${id}`, data)

/**
 * 获取课题内部所有人员列表
 * @param {*} data
 */
export const getTopicAllMemberList = (data) => get(`/api/v1_11/project/timeline/members`, data)

/**
 * 获取课题里程碑顶部列表
 * @param {*} data
 */
export const getTopicMilestoneTopList = (data) => get(`/api/v1_11/project/subject/timeline/toplist`, data)

/**
 * 获取课题下所有任务列表
 * @param {*} data
 */
export const getTopicMilestoneTaskList = (data) => get(`/api/v1_11/project/subject/timeline/list`, data)

/**
 * 获取顶部列表/任务列表
 * @param {*} data
 */
export const getTopicMilestoneAllList = (data) => get(`/api/v1_11/project/subject/timeline/alllist`, data)

/**
 * 创建里程碑节点
 * @param {*} data
 */
export const createTopicMilestoneNode = (data) => post(`/api/v1_11/project/subject/timeline/node`, data)

/**
 * 删除里程碑节点
 * @param {*} data
 */
export const deleteTopicMilestoneNode = (id, data) => remove(`/api/v1_11/project/subject/timeline/${id}/node`, data)

/**
 * 修改里程碑节点
 * @param {*} id
 * @param {*} data
 */
export const updateTopicMilestoneNode = (id, data) => put(`/api/v1_11/project/subject/timeline/${id}/node`, data)

/**
 * 创建里程碑子任务
 * @param {*} data
 */
export const createTopicMilestoneSubTask = (data) => post(`/api/v1_11/project/subject/timeline/task`, data)

/**
 * 删除里程碑子任务
 * @param {*} data
 */
export const deleteTopicMilestoneSubTask = (id, data) => remove(`/api/v1_11/project/subject/timeline/${id}/task`, data)

/**
 * 修改里程碑子任务
 * @param {*} data
 */
export const updateTopicMilestoneSubTask = (id, data) => put(`/api/v1_11/project/subject/timeline/${id}/task`, data)

/*
  ============== end 课题管理 ==================
*/

/*
  ============== start 成员 ==================
*/

/**
 * 总负责人获取成员列表
 * 按课题合并行
*/
export const getMemberListAdmin = () => get(`/api/v1_11/members/global`)

/**
 * 单位主持人获取成员列表
 * 1、这个课题其他单位负责人
 * 2、自己的单位下的成员
 */
export const getMemberListTopicAdmin = () => get(`/api/v1_11/members/sub`)

/**
 * 管理员获取项目成员
 * @param {*} data
 */
export const getProjectMemberList = (data) => get(`/api/v1_14/subject/member/list`, data)

/**
 * 更新项目成员
 * @param {*} id
 * @param {*} data
 */
export const updateProjectMember = (id, data) => put(`/api/v1_14/subject/member/${id}`, data)

/**
 * 添加项目成员
 */
export const addProjectMember = (data) => post(`/api/v1_14/subject/member`, data)

/*
  ============== end 成员 ==================
*/

/*
  ============== start 文档 ==================
*/

/**
 * 获取文档列表
 * @param {*} data
 */
export const getDocsList = (data) => get(`/api/v1_11/docs`, data)

/**
 * 获取课题&单位组合列表 [上传文档时的课题嵌套单位]
 */
export const getTopicAndUnitList = () => get(`/api/v1_11/subject/company/list`)

/**
 * 删除文档信息
 * @param {*} data
 */
export const deleteDocs = (id) => remove(`/api/v1_11/doc/${id}`)

/**
 * 添加文档信息
 * @param {*} data
 */
export const addDocs = (data) => post(`/api/v1_11/doc`, data)

/**
 * 获取文件夹/文件列表
 * @param {*} data
 */
export const getFileList = (data) => get(`/api/v2/project/subject/document/list`, data)

/**
 * 新建文件夹
 * @param {*} data
 */
export const createFolder = (data) => post(`/api/v2/project/subject/document/folder`, data)

/**
 * 新建文件
 * @param {*} data
 */
export const createFile = (data) => post(`/api/v2/project/subject/document/file`, data)

/**
 * 修改文件夹/文件名称
 * @param {*} data
 */
export const updateFileName = (id, data) => put(`/api/v2/project/subject/document/${id}/rename`, data)

/**
 * 删除单个文件
 */
export const deleteFile = (id) => remove(`/api/v2/project/subject/document/${id}`)

/**
 * 删除多个文件
 * @param {*} data
 */
export const deleteMultipleResource = (data) => remove(`/api/v2/project/subject/document/del/batch`, data)
/*
  ============== end 文档 ==================
*/

/*
  ============== start 审核消息 ==================
*/

/**
 * 总负责人获取申请课题负责人列表
 */
export const getApplyTopicAdminList = () => get(`/api/v1_11/subject/invites`)

/**
 * 总负责人同意或驳回课题负责人的申请
 * @param {*} id
 * @param {*} data
 */
export const updateApplyStatus = (id, data) => put(`/api/v1_11/subject/invite/${id}`, data)

/**
 * 1、如果当前用户是课题负责人，那么获取的就是申请（参与单位负责人）的申请和申请该课题负责人所在单位的成员的申请列表
 * 2、如果该用户是参与单位的负责人， 那么获取的就是该单位的成员申请列表
 */
export const getApplyCompanyList = () => get(`/api/v1_11/company/invites`)

/**
 * 更改企业申请状态
 * @param {*} id
 * @param {*} data
 */
export const updateCompanyApplyStatus = (id, data) => put(`/api/v1_11/company/invite/${id}`, data)

/**
 * 获取企业开支申请列表
 */
export const getCompanyExpenseList = () => get(`/api/v1_11/company/expense/invites`)

/**
 * 更改单位报销申请状态
 * @param {*} id
 * @param {*} data
 */
export const updateExpenseApplyStatus = (id, data) => put(`/api/v1_11/company/expense/${id}`, data)

/**
 * 1、成员在消息里获取审核的消息
 * 2、课题负责人获取某个单位的开支记录
 * 3、单位负责人获取自己单位的开支记录
 */
export const getCompanyExpenselogs = (data) => get(`/api/v1_11/company/expense`, data)

/**
 * 获取审核的消息数量 { 成员没有该接口 }
 */
export const getMessageCount = () => get(`/api/v1_11/notice/count`)

/*
  ============== end 审核消息 ==================
*/

/*
  ============== start 企业 ==================
*/

/**
 * 删除单位成员
*/
export const deleteUnitMember = (id) => remove(`/api/v1_11/company/member/${id}`)

/**
 * 添加单位目标
 * @param {*} id
 * @param {*} data
 */
export const addUnitTarget = (id, data) => post(`/api/v1_11/company/${id}/target`, data)

/**
 * 获取单位目标列表
 * @param {*} id
 */
export const getUnitTarget = (id) => get(`/api/v1_11/company/${id}/target_down`)

/**
 * 删除单位目标
 * @param {*} id
 */
export const deleteUnitTarget = (id, data) => remove(`/api/v1_11/company/${id}/target`, data)

/**
 * 添加开支
 * @param {*} data
 */
export const addExpense = (data) => post(`/api/v1_11/company/expense`, data)

/**
 * 获取报销申请的详情
 * @param {*} id
 */
export const getExpenseDetails = (id) => get(`/api/v1_11/company/expense/invite/${id}`)

/**
 * 获取课题企业信息
 * @param {*} id
 */
export const getTopicCompany = (id, data) => get(`/api/v1_11/subject/${id}/company`, data)

/**
 * 获取单位下拉列表
 * @param {*} data
 */
export const getCompanyDownList = (data) => get(`/api/v1_11/company/down`, data)

/*
  ============== end 企业 ==================
*/

/*
  ============== start 成果 ==================
*/

/**
 * 获取成果列表
 */
export const getCompanyAchievementList = (data) => get(`/api/v1_11/achievements`, data)

/**
 * 添加成果
 * @param {*} data
 */
export const addAchievement = (data) => post(`/api/v1_11/achievement`, data)

/**
 * 获取指定成果详情
 * @param {*} data
 */
export const getAchievementDetail = (id, data) => get(`/api/v1_11/achievement/${id}`, data)

/**
 * 删除成果
 * @param {*} id
 * @param {*} data
 */
export const deleteAchievement = (id, data) => remove(`/api/v1_11/achievement/${id}`, data)

/*
  ============== end 成果 ==================
*/

/*
  ============== start 预算 ==================
*/

/**
 * 获取经费进度
 * 【总负责人看到的是各个课题的经费进度】
 * 【课题负责人看到的是各个公司的经费进度】
 * 【单位负责人看到的是本单位的经费进度】
 */
export const getFundProgressList = () => get(`/api/v1_11/cooperation/budget/progress`)

/**
 * 获取经费开支列表
 * @param {*} data
 */
export const getFundExpenseList = (data) => get(`/api/v1_11/cooperation/budget/expense`, data)

/**
 * 批量导入开支信息
 * @param {*} data
 */
export const importFundExpenseData = (data) => post(`/api/v1_11/cooperation/budget/expense`, data)

/**
 * 获取资金来源列表
 * @param {*} projectId
 * @param {*} data
 */
export const getBudgetSourceList = (data) => get(`/api/v1_4/portal/projects/${projectId}/fund_sources`, data)

/**
 * 获取预算科目列表
 * @param {*} projectId
 * @param {*} data
 */
export const getBugdetSubjecttList = (data) => get(`/api/v1_4/portal/projects/${projectId}/subjects`, data)

/**
 * 获取项目预算
  1、项目负责人等级的查看项目预算表
  2、课题负责人查看课题表和单位表（做切换）
  3、单位负责人查看单位预算表
 */
export const getProjectFund = () => get(`/api/v1_11/cooperation/budget`)

/**
 * 更新项目预算
 * @param {*} data
 */
export const updateProjectFund = (data) => put(`/api/v1_11/project/budget`, data)

/**
 * 获取经费的导出数据 用来做预览
 * @param {*} data
 */
export const getFundExportData = (data) => get(`/api/v1_11/cooperation/budget/export`, data)

/**
 * 删除经费记录
 * @param {*} id
 */
export const deleteLog = (id) => remove(`/api/v1_11/company/expense/${id}`)

/*
  ============== end 预算 ==================
*/

/*
  ============== start 日志 ==================
*/

/**
 * 获取日志记录列表
 * @param {*} data
 */
export const getLogList = (data) => get(`/api/v1_11/cooperation/actionlog`, data)

/*
  ============== end 日志 ==================
*/

/*
  ============== start 成员审批 ==================
*/

/**
 * 获取成员审批的列表
 * @param {*} data
 */
export const getCheckMemberList = (data) => get(`/api/v1_11/cooperation/member/invites`, data)

/**
 * 更改成员状态
 * @param {*} id
 * @param {*} data
 */
export const changeCheckMemberStatus = (id, data) => put(`/api/v1_11/cooperation/member/invite/${id}`, data)

/**
 * 获取成员审核详情
 * @param {*} id
 */
export const getCheckMemberDetails = (id) => get(`/api/v1_11/cooperation/member/invite/${id}`)

/**
 * 更新成员材料
 * @param {*} id
 * @param {*} data
 */
export const updateCheckMemberAttachment = (id, data) => post(`/api/v1_11/cooperation/member/invite/${id}/attachment`, data)

/**
 * 获取待审核成员的数量
 */
export const getCheckMemberMessageCount = () => get(`/api/v1_11/cooperation/member/invites/count`)

/*
  ============== start 成员审批 ==================
*/

/*
  ============== start 预算修改 ==================
*/

/**
 * 获取指定单位预算
 * @param {*} id
 */
export const getUnitFundData = (id) => get(`/api/v1_11/cooperation/budget/company/${id}`)

/**
 * 获取课题和单位
 */
export const getTopicAndUnitFund = () => get(`/api/v1_11/cooperation/budget/subject`)

/**
 * 获取经费历史版本列表
 */
export const getFundHistoryList = () => get(`/api/v1_11/cooperation/budget/history`)

/**
 * 获取某一版经费历史记录
 * @param {*} id
 */
export const getHistoryFundData = (id) => get(`/api/v1_11/cooperation/budget/history/${id}`)

/**
 * 批量编辑的单位的预算经费
 */
export const batchUpdateUnitFund = (data) => post(`/api/v1_11/cooperation/budget/company`, data)

/*
  ============== start 预算修改 ==================
*/

/*
  ============== start 通知 ==================
*/

/**
 * 获取协作版通知设置
 * @param {*} data
 */
export const getNotificationData = (data) => get(`/api/v1_11/project/notify/setting`, data)
/**
 * 更新协作版通知设置
 * @param {*} data
 */
export const updateNotificationData = (data) => put(`/api/v1_11/project/notify/setting`, data)
/**
 * 获取协作版通知高级设置
 * @param {*} data
 */
export const getAdvanceSettingData = (data) => get(`/api/v1_11/project/notify/all`, data)

/**
 * 更新协作版通知高级设置
 * @param {*} data
 */
export const updateAdvanceSettingData = (data) => put(`/api/v1_11/project/notify/all`, data)

/*
  ============== end 通知 ==================
*/

/*
  ============== start 会议 ==================
*/

/**
 * 添加协作办会议
 * @param {*} data
 */
export const addMeeting = (data) => post(`/api/v1_11/project/conference`, data)

/**
 * 添加课题会议
 * @param {*} data
 */
export const addSubjectMeeting = (data) => post(`/api/v1_11/subject/conference`, data)

/**
 * 删除会议
 * @param {*} id
 */
export const deleteMeeting = (id) => remove(`/api/v1_11/project/conference/${id}`)

/**
 * 修改会议接口
 * @param {*} id
 * @param {*} data
 */
export const updateMeeting = (id, data) => put(`/api/v1_11/project/conference/${id}`, data)

/**
 * 获取协作版会议列表
 * @param {*} data
 */
export const getMeetingList = (data) => get(`/api/v1_11/project/conference/list`, data)

/**
 * 获取课题会议列表
 * @param {*} data
 */
export const getSubjectMeetingList = (data) => get(`/api/v1_11/subject/conference/list`, data)

/**
 * 获取协作版会议详情
 * @param {*} id
 * @param {*} data
 */
export const getMeetingDetail = (id, data) => get(`/api/v1_11/project/conference/${id}/details`, data)

/**
 * 获取会议附件列表
 * @param {*} id
 * @param {*} data
 */
export const getMeetingFileList = (id, data) => get(`/api/v1_11/project/conference/${id}/documents`, data)

/**
 * 删除协作版会议文档
 * @param {*} id
 * @param {*} data
 */
export const deleteMeetingFile = (id, data) => remove(`/api/v1_11/project/conference/${id}/document`, data)

/**
 * 添加协作办会议文档
 * @param {*} id
 * @param {*} data
 */
export const addMeetingFile = (id, data) => post(`/api/v1_11/project/conference/${id}/document`, data)

/**
 * 获取协作版用户选择列表
 */
export const getMemberList = () => get(`/api/v1_11/project/member/select`)

/*
  ============== end 会议 ==================
*/



// WEBPACK FOOTER //
// ./src/api/index.js